import { apiClient } from "helpers/api_helper";
import { SlabItem } from "../components";

export const GetAvailbaleSlabConsumerOffers = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/ConsumerOffers/GetAvailbaleSlabConsumerOffers`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const DeleteCustomerAddress = async (data: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Customer/DeleteCustomerAddress?id=${data}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const saveToCart = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/cart/AddSalesEntryToCart`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getSavedCartDetailsByCartId   = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/cart/GetSavedCartDetailsByCartId?CartId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

